import { Outlet, useLocation } from 'react-router-dom';
import { useRef } from 'react';
import Topbar from '@/components/admin/Topbar';
import MobileTopbar from '@/components/admin/MobileTopbar';
import MobileBottomNav from '@/components/admin/MobileBottomNav';
import { communityMenu } from '@/components/admin/menuConfig';
import SidebarCommunity from './SidebarCommunity';
import SEO from '@/components/common/SEO';
import { ScrollContainerProvider } from '@/contexts/ScrollContainerContext';
import { useAuth } from '@/contexts/AuthContext';
import { useSidebar } from '@/contexts/SidebarContext';
import { CoHostBanner } from '@/components/community/host-management/CoHostBanner';

const CommunityLayout = () => {
  const { isCollapsed } = useSidebar();
  const location = useLocation();
  const mobileMainRef = useRef<HTMLElement>(null);
  const { isCoHost } = useAuth();

  const activeParent = communityMenu.find(
    (item) =>
      (location.pathname.startsWith(item.path) && item.path !== '/host') ||
      location.pathname === item.path
  );
  const hasChildren = activeParent?.children && activeParent.children.length > 0;

  const isGameCreateOrEdit =
    location.pathname.includes('/game/create') ||
    (location.pathname.includes('/game/') && location.pathname.includes('/edit'));

  const isPadelTambahGame = location.pathname.includes('/padel/tambah-game');

  const isSportComposer =
    location.pathname.includes('/badminton/tambah-game') ||
    /\/badminton\/game\/[^/]+\/skor$/.test(location.pathname) ||
    isPadelTambahGame ||
    /\/padel\/game\/[^/]+\/skor$/.test(location.pathname);

  const isNoTopbar =
    !isGameCreateOrEdit &&
    !isPadelTambahGame &&
    (location.pathname === '/host/profile-settings' ||
      location.pathname === '/host/profile-settings/' ||
      location.pathname.includes('/mabar/create') ||
      isSportComposer ||
      (location.pathname.includes('/mabar/') && location.pathname.includes('/edit')));

  const isHideBottomNav =
    location.pathname.includes('/rekap') ||
    location.pathname.includes('/game/create') ||
    location.pathname.includes('/mabar/create') ||
    isSportComposer ||
    (location.pathname.includes('/mabar/') && location.pathname.includes('/edit')) ||
    (location.pathname.includes('/game/') && location.pathname.includes('/edit')) ||
    location.pathname.startsWith('/host/cash') ||
    location.pathname === '/cash' ||
    location.pathname.startsWith('/cash');

  const isProfileSettings = location.pathname.startsWith('/host/profile-settings');
  const showCoHostBanner = isCoHost && !isProfileSettings;

  return (
    <>
      <SEO
        title="Sporto Community"
        description="Dashboard community Sporto"
        url="/host"
        noIndex={true}
      />
      <div className="min-h-screen hidden md:flex bg-gray-50 overflow-x-hidden">
        <aside
          className={`shrink-0 bg-white border-r transition-[width] duration-300 ease-in-out relative z-20 ${
            isCollapsed ? 'w-20' : 'w-64'
          }`}
        >
          <SidebarCommunity />
        </aside>
        <div className="flex-1 min-w-0 overflow-x-hidden">
          <Topbar page="community" />
          {showCoHostBanner && <CoHostBanner />}
          <main className="p-6 overflow-x-hidden">
            <Outlet />
          </main>
        </div>
      </div>

      <div className="md:hidden min-h-screen flex flex-col bg-white">
        {!isNoTopbar && <MobileTopbar menuItems={communityMenu} />}
        {showCoHostBanner && (
          <div
            className={`fixed left-0 right-0 z-30 ${
              isNoTopbar
                ? 'top-[var(--safe-area-inset-top,env(safe-area-inset-top,0px))]'
                : 'top-[calc(3.5rem+var(--safe-area-inset-top,env(safe-area-inset-top,0px)))]'
            }`}
          >
            <CoHostBanner />
          </div>
        )}

        <ScrollContainerProvider value={mobileMainRef}>
          <main
            ref={mobileMainRef}
            className={`flex-1 overflow-auto bg-gray-50 transition-all duration-200 ${
              isHideBottomNav ? 'pb-0' : 'pb-24 md:pb-0'
            } ${
              isNoTopbar
                ? showCoHostBanner
                  ? 'pt-safe-offset-8'
                  : 'pt-safe'
                : hasChildren
                  ? showCoHostBanner
                    ? 'pt-safe-offset-36'
                    : 'pt-safe-offset-28'
                  : showCoHostBanner
                    ? 'pt-safe-offset-24'
                    : 'pt-safe-offset-16'
            }`}
          >
            <Outlet />
          </main>
        </ScrollContainerProvider>

        {!isHideBottomNav && <MobileBottomNav items={communityMenu} />}
      </div>
    </>
  );
};

export default CommunityLayout;
